import { render, staticRenderFns } from "./DoorareaCard.vue?vue&type=template&id=7cf238c2&"
import script from "./DoorareaCard.vue?vue&type=script&lang=js&"
export * from "./DoorareaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports